import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Grid, Card, CardContent, Typography, Paper, Chip, Pagination, TextField, InputAdornment, IconButton, CircularProgress } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef, useCallback } from "react";
import { t } from "i18next";
import { io } from "socket.io-client";
import SearchIcon from '@mui/icons-material/Search';

import xx1 from "../../static/txmd5/xx1_1.png";
import xx2 from "../../static/txmd5/xx2_1.png";
import xx3 from "../../static/txmd5/xx3_1.png";
import xx4 from "../../static/txmd5/xx4_1.png";
import xx5 from "../../static/txmd5/xx5_1.png";
import xx6 from "../../static/txmd5/xx6_1.png";

const diceImages = { 1: xx1, 2: xx2, 3: xx3, 4: xx4, 5: xx5, 6: xx6 };
const SERVER_URL = process.env.REACT_APP_API_URL_MAIN;
const SOCKET_URL = process.env.REACT_APP_API_URL_SOCKET_TXMD560S;

function SetTXMD5() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [rawTime, setRawTime] = useState(0);
    const [displayTime, setDisplayTime] = useState(0);
    const [gameState, setGameState] = useState("");
    const [phien, setPhien] = useState("...");
    const [result, setResult] = useState("...");

    const [totalMoneyTai, setTotalMoneyTai] = useState(0);
    const [totalMoneyXiu, setTotalMoneyXiu] = useState(0);
    const [usersTai, setUsersTai] = useState([]);
    const [usersXiu, setUsersXiu] = useState([]);

    const [listSessionHistory, setListSessionHistory] = useState([]); 
    const [listPlayerHistory, setListPlayerHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    
    const socketRef = useRef();

    function formatDateTimeFull(dateStr) {
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    useEffect(() => {
        socketRef.current = io(SOCKET_URL);

        socketRef.current.on("tx_time", (data) => {
            const serverTime = data.time;
            setRawTime(serverTime);

            if (serverTime > 15) {
                setDisplayTime(serverTime - 15);
                setGameState("ĐANG ĐẶT CƯỢC");
            } else {
                setDisplayTime(serverTime);
                setGameState("TRẢ THƯỞNG / MỞ BÁT");
            }

            if (data.data) setPhien(data.data.id_bet);

            if (data.lists) {
                const listTai = data.lists.tai || [];
                const listXiu = data.lists.xiu || [];
                setUsersTai(listTai);
                setUsersXiu(listXiu);
                setTotalMoneyTai(listTai.reduce((sum, item) => sum + Number(item.money), 0));
                setTotalMoneyXiu(listXiu.reduce((sum, item) => sum + Number(item.money), 0));
            }
        });

        socketRef.current.on("tx_result", (data) => {
            setResult(data.result);
            fetchHistorySession();
        });

        socketRef.current.on("tx_new_session", (data) => {
            setPhien(data.id_bet);
            setResult("...");
            setTotalMoneyTai(0); setTotalMoneyXiu(0);
            setUsersTai([]); setUsersXiu([]);
        });

        fetchHistorySession();
        fetchPlayerHistory(1, "", false); 

        return () => {
            if (socketRef.current) socketRef.current.disconnect();
        };
    }, []);

    const fetchPlayerHistory = useCallback((pageNum, keyword, isSilent = false) => {
        if (!isSilent) setIsLoadingHistory(true); 
        const query = keyword ? `&username=${keyword}` : "";
        axios.get(`${SERVER_URL}/taixiumd560s/history-all-players?page=${pageNum}&limit=10${query}`)
            .then((res) => {
                if (res.data.success) {
                    setListPlayerHistory(res.data.data);
                    setTotalPages(res.data.totalPages || 1);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                if (!isSilent) setIsLoadingHistory(false);
            });
    }, []);

    useEffect(() => {
        const silentUpdateTimer = setInterval(() => {
            fetchPlayerHistory(page, searchKeyword, true); 
        }, 3000);
        return () => clearInterval(silentUpdateTimer);
    }, [page, searchKeyword, fetchPlayerHistory]);

    const fetchHistorySession = () => {
        axios.get(`${SERVER_URL}/taixiumd560s/getallbet?limit=20`).then((res) => {
            if (res.data.success) {
                const filteredData = res.data.data.filter(item => item.result);
                setListSessionHistory(filteredData.slice(0, 20)); 
            }
        }).catch(() => {});
    };

    const handleSearch = () => { setPage(1); fetchPlayerHistory(1, searchKeyword, false); };

    const formatMoney = (n) => String(n ? n : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const UserListTable = ({ users, title, color }) => (
        <Paper sx={{ maxHeight: 300, overflow: 'auto', bgcolor: '#f5f5f5', border: `1px solid ${color}` }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold', color: color, bgcolor: '#eee' }}>User ({users.length})</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: color, textAlign: 'right', bgcolor: '#eee' }}>Tiền</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users && users.length > 0 ? (
                        users.map((u, i) => (
                            <TableRow key={i}>
                                <TableCell>{u.user?.username || "Ẩn danh"}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#333' }}>{formatMoney(u.money)}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow><TableCell colSpan={2} align="center" sx={{ color: '#aaa', py: 3 }}>Trống</TableCell></TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayoutCustomer>
                <Box component="main" sx={{ flexGrow: 1, py: 2, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
                    <Container maxWidth={false}>
                        <div className="container_set" style={{ fontSize: '28px', fontWeight: '900', marginBottom: '20px', textAlign: 'center', color: '#10B981', textTransform: 'uppercase' }}>
                            THEO DÕI TÀI XỈU MD5
                        </div>

                        <Grid container spacing={2} sx={{mb: 2}}>
                            <Grid item xs={12}>
                                <Card sx={{ border: '1px solid #ddd', boxShadow: 2 }}>
                                    <CardContent>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={6} style={{ textAlign: 'center' }}>
                                                <Typography variant="h6" color="textSecondary">PHIÊN HIỆN TẠI</Typography>
                                                <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold' }}>#{phien}</Typography>
                                                <div style={{ fontSize: '60px', fontWeight: 'bold', color: rawTime <= 15 ? '#D32F2F' : '#10B981', fontFamily: 'monospace', lineHeight: 1 }}>{displayTime}</div>
                                                <Typography variant="body2">{gameState}</Typography>
                                            </Grid>
                                            <Grid item xs={6} style={{ textAlign: 'center' }}>
                                                <Typography variant="h6" color="textSecondary">KẾT QUẢ</Typography>
                                                <Typography variant="h3" color="secondary" sx={{ fontWeight: 'bold' }}>{result}</Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} sx={{mb: 4}}>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ bgcolor: '#fff', borderTop: '5px solid #000', boxShadow: 2 }}>
                                    <CardContent>
                                        <Box sx={{ textAlign: 'center', mb: 1, bgcolor: '#000', p: 1, borderRadius: 1, color: '#fff' }}>
                                            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>⚫ TÀI - <span style={{color: '#10B981'}}>{formatMoney(totalMoneyTai)}</span></Typography>
                                        </Box>
                                        <UserListTable users={usersTai} title="Tài" color="#000" />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ bgcolor: '#fff', borderTop: '5px solid #D32F2F', boxShadow: 2 }}>
                                    <CardContent>
                                        <Box sx={{ textAlign: 'center', mb: 1, bgcolor: '#D32F2F', p: 1, borderRadius: 1, color: '#fff' }}>
                                            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>⚪ XỈU - <span style={{color: '#FFEB3B'}}>{formatMoney(totalMoneyXiu)}</span></Typography>
                                        </Box>
                                        <UserListTable users={usersXiu} title="Xỉu" color="#D32F2F" />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                     

                       
                    </Container>
                </Box>
            </DashboardLayoutCustomer>
        </ThemeProvider>
    );
}

export default SetTXMD5;